import React from 'react';

function MatchDetailsModal({ match, onClose, onRegister, isRegistered }) {
    if (!match) return null;

    const prizePool = match.prize_pool_bigint ? (match.prize_pool_bigint / 100) : 0;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div
                className="modal"
                onClick={(e) => e.stopPropagation()}
                style={{ maxWidth: '600px', maxHeight: '90vh', overflow: 'auto' }}
            >
                <div className="modal-header">
                    <div>
                        <h3 className="modal-title">{match.title}</h3>
                        <div style={{ fontSize: '0.9rem', color: 'var(--text-secondary)', marginTop: '5px' }}>
                            ID: {match.id.slice(0, 8)}...
                        </div>
                    </div>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>

                <div style={{ paddingBottom: '20px' }}>
                    {/* Main Info Grid */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, 1fr)',
                        gap: '15px',
                        marginBottom: '20px',
                        background: 'var(--accent-bg)',
                        padding: '15px',
                        borderRadius: '8px'
                    }}>
                        <div>
                            <label style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>MODE</label>
                            <div style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>{match.mode}</div>
                        </div>
                        <div>
                            <label style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>MAP</label>
                            <div style={{ fontWeight: 'bold' }}>{match.map}</div>
                        </div>
                        <div>
                            <label style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>FORMAT</label>
                            <div style={{ fontWeight: 'bold' }}>{match.format || 'TPP'}</div>
                        </div>
                        <div>
                            <label style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>TOTAL ENTRY FEE</label>
                            <div style={{ fontWeight: 'bold', color: 'var(--primary-color)' }}>₹{match.entry_fee}</div>
                        </div>

                        {/* Per Player Cost */}
                        {match.mode !== 'solo' && match.entry_fee > 0 && (
                            <div>
                                <label style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>PER PLAYER</label>
                                <div style={{ fontWeight: 'bold' }}>
                                    ₹{match.mode === 'duo' ? match.entry_fee / 2 : match.entry_fee / 4}
                                </div>
                            </div>
                        )}

                        {/* Per Kill Display */}
                        {match.per_kill > 0 && (
                            <div>
                                <label style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>PER KILL</label>
                                <div style={{ fontWeight: 'bold', color: '#ff4757' }}>₹{match.per_kill}</div>
                            </div>
                        )}
                    </div>

                    {/* Prize Pool Highlight */}
                    {prizePool > 0 && (
                        <div style={{
                            textAlign: 'center',
                            padding: '20px',
                            background: 'linear-gradient(45deg, rgba(255, 215, 0, 0.1), rgba(255, 165, 0, 0.1))',
                            borderRadius: '8px',
                            border: '1px solid rgba(255, 215, 0, 0.3)',
                            marginBottom: '20px'
                        }}>
                            <label style={{ fontSize: '0.9rem', color: 'var(--warning-color)', textTransform: 'uppercase', letterSpacing: '1px' }}>Total Prize Pool</label>
                            <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#ffb700', textShadow: '0 0 10px rgba(255, 183, 0, 0.3)' }}>
                                ₹{prizePool}
                            </div>
                        </div>
                    )}

                    {/* Description */}
                    {match.description && (
                        <div style={{ marginBottom: '20px' }}>
                            <h4 style={{ marginBottom: '10px', fontSize: '1.1rem' }}>📝 Description & Rules</h4>
                            <div style={{
                                background: 'rgba(255, 255, 255, 0.05)',
                                padding: '15px',
                                borderRadius: '8px',
                                whiteSpace: 'pre-wrap',
                                lineHeight: '1.5',
                                fontSize: '0.9rem',
                                color: 'var(--text-secondary)'
                            }}>
                                {match.description}
                            </div>
                        </div>
                    )}

                    {/* Schedule */}
                    <div style={{ marginBottom: '20px' }}>
                        <h4 style={{ marginBottom: '10px', fontSize: '1.1rem' }}>📅 Schedule</h4>
                        <div style={{
                            display: 'flex',
                            gap: '20px',
                            background: 'rgba(255, 255, 255, 0.05)',
                            padding: '15px',
                            borderRadius: '8px'
                        }}>
                            <div>
                                <span style={{ color: 'var(--text-secondary)', marginRight: '8px' }}>Date:</span>
                                <strong>{new Date(match.start_ts).toLocaleDateString()}</strong>
                            </div>
                            <div>
                                <span style={{ color: 'var(--text-secondary)', marginRight: '8px' }}>Time:</span>
                                <strong>{new Date(match.start_ts).toLocaleTimeString()}</strong>
                            </div>
                        </div>
                    </div>

                    {/* Action */}
                    {onRegister && (
                        <button
                            className="btn btn-primary"
                            style={{ width: '100%', padding: '12px', fontSize: '1.1rem' }}
                            onClick={onRegister}
                            disabled={
                                isRegistered ||
                                match.registrations_count >= match.slot_count ||
                                new Date(match.start_ts) < new Date()
                            }
                        >
                            {isRegistered
                                ? 'Registered'
                                : new Date(match.start_ts) < new Date()
                                    ? 'Match Ended'
                                    : match.registrations_count >= match.slot_count
                                        ? 'Full'
                                        : 'Register Now'
                            }
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default MatchDetailsModal;
